module.exports = __webpack_public_path__ + "static/media/facebook.f03ed99e.svg";